// @/app/components/ui/PetUpdateModal/index.tsx

import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import AddCustomerForms from "@/app/components/routes/auth_routes/CustomerProfile/AddCustomer/AddCustomerForms";

interface IPetUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  errorSource: number | null;
}


const PetUpdateModal: React.FC<IPetUpdateModalProps> = ({ isOpen, onClose, onSuccess, errorSource }) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const title = errorSource === 1 ? "Update Pet Weight" : "Update Pet Weight & DOB";
  const description =
    errorSource === 1
      ? "Please update pet weight to continue adding items to cart."
      : "Please update pet weight and date of birth to continue adding items to cart.";

  return createPortal(
    <div
      ref={overlayRef}
      onClick={(e) => { if (e.target === overlayRef.current) onClose(); }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pet-update-modal-title"
    >
      <div className="relative w-full max-w-5xl max-h-[90vh] overflow-y-auto bg-white rounded-2xl shadow-2xl flex flex-col">

        {/* Header */}
        <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-8 py-6 flex items-start justify-between rounded-t-2xl">
          <div>
            <h2 id="pet-update-modal-title" className="text-xl font-bold  text-red-400">
              {title}
            </h2>
            <p className="text-sm  mt-1 text-red-400">{description}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close dialog"
            className="ml-4 p-2 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>

        <div className="px-4 py-6 flex-1">
          <AddCustomerForms
            layoutFor="PET"
            forUpdate={true}
            addressLayout="SINGLE"
            updatePetWeightViaCart={true}
            addons={{
              case: "CART_PET_UPDATE",
              onSuccess: () => {
                onClose();
                onSuccess();
              },
              onFailure: () => {
                onClose();
              },
            }}

            hideTitle={true}
          />
        </div>

      </div>
    </div>,
    document.body,
  );
};

export default PetUpdateModal;
